import UIConfig from '@onereach/ui-config';

type RuntimeConfig = {
  HITL_UI_ALIASES?: string[];
};

export const getUIConfig = () => {
  return UIConfig(
    OR_CONFIG,
    OR_PLATFORM_CONFIG,
    OR_LOCAL_CONFIG,
    true,
    undefined,
    (runtimeConfig: RuntimeConfig) => runtimeConfig.HITL_UI_ALIASES,
  );
};
